// src/components/Auth.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { TextField, Button, Paper, Typography, Box } from '@mui/material';
import "./LoginPage.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { signIn, signUp } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    try {
      if (isLogin) {
        await signIn(email, password);
      } else {
        await signUp(email, password);
      }
      navigate('/');
    } catch (error) {
      const errorMessage = error.message
        .replace('Firebase: Error ', '')
        .replace(/\(auth.*\)/, '');
      setError(errorMessage);
    }
  };

  return (
    <div className="auth-container">
      <Paper elevation={3} className="auth-paper">
        <Box className="auth-content">
          <Typography variant="h3" className="welcome-title">
            Welcome to Last Layer
          </Typography>
          
          <Typography variant="h5" className="auth-subtitle">
            {isLogin ? "Sign In" : "Create Account"}
          </Typography>

          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit} className="auth-form">
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              variant="outlined"
              fullWidth
              className="auth-input"
            />
            
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              fullWidth
              className="auth-input"
            />

            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
              fullWidth
              className="auth-submit-button"
            >
              {isLogin ? "Sign In" : "Create Account"}
            </Button>
          </form>

          <Button
            onClick={() => setIsLogin(!isLogin)}
            className="auth-switch-button"
          >
            {isLogin ? "Need an account? Register" : "Already have an account? Login"}
          </Button>
        </Box>
      </Paper>
    </div>
  );
};

export default LoginPage;

